<template>
  <div class="order-search-container" style="padding-top: 10px">
    <el-form :model="searchCondition" :inline="true" class="form" size="mini" @submit.native.prevent>
      <el-row>
        <el-col v-has-item="{configs:configs,instruct:'customer_id'}" :span="9">
          <el-form-item label="" class="search-item">
            <CompanySelect :company-id.sync="searchCondition.company_id" multiple history
                           class="company"/>
            <CustomerRemoteSelect multiple :model-value.sync="searchCondition.customer_id" class="customer"
                                  style="display: inline;"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'artist_id'}" :span="6">
          <el-form-item :label="''" class="search-item">
            <PinYinMatchSelect :data="optionsMap.artistOption" :is-multiple="true"
                               :model-value.sync="searchCondition.artist_id" style="width: 100%"
                               placeholder="红人名称" @change="onSubmit" @focus="getFBoySelectList"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'created_at'}" :span="9">
          <el-form-item :label="''" class="search-item">
            <el-date-picker
                v-model="searchCondition.timeRange"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width: 100%;margin-left: 6px"
                @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'time_type'}" :span="9">
          <el-form-item :label="''" class="search-item">
            <el-select v-model="searchCondition.time_type" style="width: 110px;margin-right: 0"
                       @change="onSubmit"
                       placeholder="时间类型"
                       clearable>
              <el-option v-for="item in searchSelectOptions.datetimeOptions" :key="item.value"
                         :value="item.value"
                         :label="item.label"/>
            </el-select>
            <el-date-picker
                v-model="searchCondition.timeRange"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width: calc(100% - 116px);margin-left: 6px"
                @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'project_name'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-input placeholder="项目名称" v-model="searchCondition.project_name" @change="onSubmit" clearable/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'order_source'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.order_source" :is-multiple="true"
                               placeholder="订单来源" class="width-100"
                               :model-value.sync="searchCondition.order_source"
                               @change="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'activation_type'}" :span="3">
          <el-form-item v-show="isMoreQueryShow" class="search-item">
            <el-select v-model="searchCondition.activation_type" placeholder="老客激活" clearable>
              <el-option label="常规" :value="0"></el-option>
              <el-option label="小组老客激活" :value="1"></el-option>
              <el-option label="公司老客激活" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'bool_exec'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.boolExecOptions" :is-multiple="true"
                               :model-value.sync="searchCondition.bool_exec" class="width-100"
                               placeholder="执行状态" @change="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_trailer'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.isTrailerOptions"
                               :model-value.sync="searchCondition.is_trailer"
                               :is-multiple="true" class="width-100"
                               placeholder="是否挂车" @change="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_lb'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.isLbOptions"
                               :model-value.sync="searchCondition.is_lb"
                               :is-multiple="true" class="width-100"
                               placeholder="是否直播" @change="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'executor_id'}" :span="3">
          <el-form-item :label="``" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.executors"
                               :is-multiple="true"
                               placeholder="执行人" class="width-100"
                               :model-value.sync="searchCondition.executor_id"
                               @change="onSubmit" @focus="getOptionExecutor"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'pay_status'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <el-select class="el-input-c" v-model="searchCondition.pay_status" clearable filterable
                       :multiple="true"
                       placeholder="回款状态"
                       @change="onSubmit"
                       :collapse-tags="searchCondition.pay_status&&searchCondition.pay_status.length>2"
            >
              <el-option v-for="(item, index) in optionsMap.payStatusOptions" :key="index"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'invoice_status'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <el-select class="el-input-c" v-model="searchCondition.invoice_status" clearable filterable
                       :multiple="true"
                       placeholder="发票状态"
                       @change="onSubmit"
                       :collapse-tags="searchCondition.invoice_status&&searchCondition.invoice_status.length>2"
            >
              <el-option v-for="(item, index) in optionsMap.invoiceStatusOptions" :key="index"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_can_invoice'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_can_invoice" clearable v-show="isMoreQueryShow"
                       placeholder="能否开票"
                       @change="onSubmit">
              <el-option value="Y" label="能"/>
              <el-option value="N" label="不能"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'invoice_number'}" :span="3">
          <el-form-item v-show="isMoreQueryShow" class="search-item">
            <el-input v-model="searchCondition.invoice_number" placeholder="发票号码" @change="onSubmit" clearable/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'sale_id'}" :span="3">
          <el-form-item :label="''" v-show="isMoreQueryShow" class="search-item">
            <PinYinMatchSelect :data="optionsMap.saleOption" :is-multiple="true"
                               placeholder="销售" class="width-100"
                               :model-value.sync="searchCondition.sale_id"
                               @change="onSubmit" @focus="getOptionSales"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'customer_nature'}" :span="3">
          <el-form-item :label="''" v-show="isMoreQueryShow" class="search-item">
            <el-select v-model="searchCondition.customer_nature"
                       placeholder="请选择客户性质"
                       @change="onSubmit"
                       filterable clearable>
              <el-option-group :label="`客户性质`">
                <el-option v-for="(item, index) in customerNaturesOptions" :key="index" :label="item"
                           :value="item"/>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'platform'}" :span="3">
          <el-form-item :label="''" v-show="isMoreQueryShow"
                        class="search-item">
            <PlatformSelect :data-value="searchCondition.platform" @change="changePlatform"
                            placeholder="平台"
                            class="width-100"></PlatformSelect>
          </el-form-item>
        </el-col>
        <!--        <el-col v-has-item="{configs:configs,instruct:'artist_id'}" :span="3">-->
        <!--          <el-form-item :label="''" v-show="isMoreQueryShow" class="search-item">-->
        <!--            <PinYinMatchSelect :data="optionsMap.artistOption" :is-multiple="true"-->
        <!--                               :model-value.sync="searchCondition.artist_id" style="width: 100%"-->
        <!--                               placeholder="红人名称" @change="onSubmit" @focus="getFBoySelectList"/>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col v-has-item="{configs:configs,instruct:'agent_name'}" :span="3">
          <el-form-item :label="''" v-show="isMoreQueryShow" class="search-item">
            <el-input v-model="searchCondition.agent_name" placeholder="经纪人" @change="onSubmit" clearable/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'brand'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-input v-model="searchCondition.brand" placeholder="品牌"
                      @change="onSubmit" clearable/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'product_category'}" :span="3">
          <el-form-item class="search-item" v-show="isMoreQueryShow">
            <el-select class="el-input-c"
                       v-model="searchCondition.product_category"
                       placeholder="请选择品类"
                       @change="onSubmit"
                       filterable
                       clearable>
              <el-option-group
                  :label="`品类(${optionsMap.productCategoriesOptions?optionsMap.productCategoriesOptions.length:0})`">
                <el-option
                    v-for="item in optionsMap.productCategoriesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'order_type'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.order_type" clearable placeholder="订单类型"
                       @change="onSubmit">
              <el-option value="regular" label="普通订单"></el-option>
              <el-option value="strike" label="冲账订单"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'order_no'}" :span="6">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <s-order-nos :value.sync="searchCondition.order_nos"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'bool_undo'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.bool_undo" clearable placeholder="是否撤单"
                       @change="onSubmit">
              <el-option :value="0" label="未撤单"></el-option>
              <el-option :value="1" label="已撤单"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="!pureLive" v-has-item="{configs:configs,instruct:'form_of_cooperations'}" :span="3">
          <el-form-item label="" prop="form_of_cooperation" v-show="isMoreQueryShow">
            <PinYinMatchSelect :data="optionsMap.form_of_cooperations" placeholder="合作形式"
                               class="width-100"
                               :model-value.sync="searchCondition.form_of_cooperation"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'contract_filed'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.contract_filed" clearable
                       placeholder="合同归档"
                       @change="onSubmit">
              <el-option :value="0" label="未归档"></el-option>
              <el-option :value="1" label="已归档"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'contract_no'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-input v-model="searchCondition.contract_no" placeholder="合同编号"
                      @change="onSubmit" clearable/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_mark_invoiced'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_mark_invoiced" clearable v-show="isMoreQueryShow"
                       placeholder="标记开票"
                       @change="onSubmit">
              <el-option value="N" label="未标记"/>
              <el-option value="Y" label="已标记"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'is_mark_rebate'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_mark_rebate" clearable v-show="isMoreQueryShow"
                       placeholder="标记返点"
                       @change="onSubmit">
              <el-option value="N" label="未标记"/>
              <el-option value="Y" label="已标记"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'is_verify_rebate'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_verify_rebate" clearable v-show="isMoreQueryShow"
                       placeholder="核对返点"
                       @change="onSubmit">
              <el-option value="N" label="未核对"/>
              <el-option value="Y" label="已核对"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'organization_id'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.organization_id" clearable v-show="isMoreQueryShow"
                       :collapse-tags="searchCondition.organization_id&&searchCondition.organization_id.length>2"
                       placeholder="销售小组" multiple @change="onSubmit">
              <el-option v-for="item in organizationOptions" :key="item.id" :value="item.id"
                         :label="item.label"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'is_new_customer'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_new_customer" clearable v-show="isMoreQueryShow"
                       :collapse-tags="searchCondition.is_new_customer&&searchCondition.is_new_customer.length>2"
                       placeholder="是否新客" @change="onSubmit">
              <el-option v-for="item in searchSelectOptions.isNewCustomer" :key="item.value"
                         :value="item.value"
                         :label="item.label"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'bool_covenant'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.bool_covenant" clearable v-show="isMoreQueryShow"
                       :collapse-tags="searchCondition.bool_covenant&&searchCondition.bool_covenant.length>2"
                       placeholder="是否有效" @change="onSubmit">
              <el-option v-for="item in searchSelectOptions.boolCovenant" :key="item.value"
                         :value="item.value"
                         :label="item.label"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'is_done_invoice'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_done_invoice" clearable v-show="isMoreQueryShow"
                       placeholder="发票开完"
                       @change="onSubmit">
              <el-option value="N" label="未开完"/>
              <el-option value="Y" label="已开完"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'back_money_way'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.back_money_way" clearable v-show="isMoreQueryShow"
                       placeholder="回款方式"
                       @change="onSubmit">
              <el-option value="import" label="导入认领"/>
              <el-option value="hand" label="手动添加"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'is_quantity'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_quantity" clearable v-show="isMoreQueryShow"
                       placeholder="是否保量"
                       @change="onSubmit">
              <el-option value="Y" label="是"/>
              <el-option value="N" label="否"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'oth_order_no'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <s-oth-order-nos :value.sync="searchCondition.oth_order_nos"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'strategy_id'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <UserRoleSelect placeholder="请选择策略" :role-name="`Strategy`" :user-id.sync="searchCondition.strategy_id"
                            @selected="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'planner_id'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <UserRoleSelect placeholder="请选择策划" :role-name="`Planner`" :user-id.sync="searchCondition.planner_id"
                            @selected="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs,instruct:'medium_id'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <UserRoleSelect placeholder="请选择媒介" :role-name="`Medium`" :user-id.sync="searchCondition.medium_id"
                            @selected="onSubmit"/>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_done_order'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_done_order" clearable v-show="isMoreQueryShow"
                       placeholder="是否完结"
                       @change="onSubmit">
              <el-option value="0" label="未完结"/>
              <el-option value="1" label="已完结"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'is_done_stage'}" :span="3">
          <el-form-item label="" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.is_done_stage" clearable v-show="isMoreQueryShow"
                       placeholder="进度是否完成"
                       @change="onSubmit">
              <el-option value="N" label="未完成"/>
              <el-option value="Y" label="已完成"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'trade'}" :span="3">
          <el-form-item :label="''" class="search-item" v-show="isMoreQueryShow">
            <el-select v-model="searchCondition.trade"
                       placeholder="请选择行业"
                       @change="onSubmit"
                       filterable clearable>
              <el-option-group :label="`请选择行业`">
                <el-option v-for="(item, index) in customerTypesOptions" :key="index" :label="item"
                           :value="item"/>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-has-item="{configs:configs,instruct:'exec_customer_id'}" :span="3">
          <el-form-item label="" v-show="isMoreQueryShow" class="search-item">
            <exec-corp-select :exec-customer-id.sync="searchCondition.exec_customer_id" multiple history />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="handel" style="margin-top: 10px;">
        <el-button type="primary" class="el-button--operation" @click="handleQuery" icon="el-icon-search">查询
        </el-button>
        <el-button @click="onReset" style="margin-right:10px;" icon="el-icon-refresh">重置</el-button>
        <el-link v-if="!fixMoreQuery" type="primary" @click="isMoreQueryShow=!isMoreQueryShow"
                 style="margin-right: 10px;">
          更多查询 <i :class="isMoreQueryShow?'el-icon-arrow-up':'el-icon-arrow-down'"/></el-link>
        <!--        导出组件：导出功能和历史导出记录-->
        <el-radio-group v-if="showOrderWay" v-model="searchCondition.orderBy" style="display: inline">
          <el-radio-button :label="item.value" v-for="(item,index) in orderByOptions"
                           :key="index">{{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <AdExport :search-condition="handleSearchCondition()" btnType="text" class="btn-export"
                  btnTypeText="导出订单"
                  v-if="userAuth.can_export_adv_order&&canExport"/>
        <slot/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {getFBoyOption} from "@/api/fboy";
import {getOptionItems, getOptionsForSelect} from "@/api/option";
import AdExport from "@/views/adOrder/components/AdExport";
import CompanySelect from "@/views/adOrder/components/companySelect";
import ExecCorpSelect from "@/views/adOrder/components/ExecCorpSelect.vue";
import CustomerRemoteSelect from "@/views/custom/components/CustomerRemoteSelect";
import {filterSearchCondition, searchConfigs, searchSelectOptions} from "@/views/adOrder";
import {options} from "@/api/organization";
import {shortcutsDateOptions} from "@/config/business";
import {optionsUsers} from "@/api/adOrder";
import UserRoleSelect from "@/components/user/UserRoleSelect.vue";
import SOrderNos from "./SearchFormOrderNo.vue";
import SOthOrderNos from "./SearchFormOthOrderNo.vue";

const checkHasItem = function (el, binding) {
  const {value} = binding
  const {configs, instruct} = value
  const bool = configs.find(_ => _ === instruct)

  if (!bool) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  name: "AdOrderSearchForm",
  components: {SOrderNos, UserRoleSelect, CustomerRemoteSelect, CompanySelect, ExecCorpSelect, AdExport, SOthOrderNos},
  directives: {
    'has-item': {
      inserted(el, binding) {
        checkHasItem(el, binding)
      },
      update(el, binding) {
        checkHasItem(el, binding)
      }
    }
  },
  props: {
    queryParams: {
      type: Object
    },
    fixMoreQuery: Boolean,
    defaultTimeQuery: Boolean,
    pureLive: Boolean,//纯直播
    configs: {
      type: Array,
      default() {
        return [...[], ...searchConfigs]
      }
    },
    canExport: {
      type: Boolean,
      default() {
        return true
      }
    },
    showOrderWay: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      that: this,
      searchSelectOptions,
      pickerOptions: shortcutsDateOptions,
      orderOptions: [],
      organizationOptions: [],
      orderByOptions: [
        {value: '`id` desc', label: '创建逆序'},
        {value: '`agent_name` asc, `artist_id` asc', label: '经纪人/红人顺序'},
      ],
      timestampQuery: [],
      isMoreQueryShow: false,
      //下拉框数据
      optionsMap: {...{}, ...searchSelectOptions},
      optionsItem: ["order_source", 'form_of_cooperation', 'product_category', 'customer_natures'],
      customerNaturesOptions: [],
      customerTypesOptions: [],
      // 搜索订单编号
      dialogSearchOrderNos: {
        show: false,
        value: null
      }
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    searchCondition: {
      get() {
        return this.queryParams
      },
      set(val) {
        this.$emit('update:query-params', val)
      }
    }
  },
  created() {
    this.searchCondition.timeRange = this.defaultDates()
  },
  mounted() {
    //默认时间
    this.getOptions(this.optionsItem);
    this.isMoreQueryShow = this.fixMoreQuery
    this.getTeamList()
    this.getCustomerNaturesOptions()
    // this.onReset()
  },
  methods: {
    defaultDates() {
      if (!this.defaultTimeQuery) {
        return []
      }
      let today = this.getLastDays(0)
      let last30Day = this.getLastDays(30)
      return [last30Day, today]
    },
    getLastDays(days) {
      //几天前的时间
      let day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * days);
      return day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
    },
    onReset() {
      const obj = {
        time_type: 'created_timestamp',
        timeRange: [],
        orderBy: '`id` desc',
        agent_name: null,
        brand: null,
        company_id: null,
        form_of_cooperation: null,
        order_type: null,
        bool_undo: 0,
        contract_no: null,
        contract_filed: null,
        customer_id: [],
        order_no: [],
        order_nos: '',
        oth_order_no: [],
        oth_order_nos: '',
        is_lb: [],
        is_trailer: [],
        pay_status: [],
        invoice_status: [],
        sale_id: [],
        platform: [],
        order_source: [],
        artist_id: [],
        organization_id: [],
        bool_exec: [],
        exec_customer_id: [],
        is_mark_invoiced: null,
        invoice_number: null,
        is_can_invoice: null,
        customer_nature: null
      }
      //若是按 红人排序的权限，则重置为红人排序
      if (this.userAuth.can_export_by_agent_name) {
        obj.orderBy = '`agent_name` asc, `artist_id` asc'
      }
      obj.timeRange = this.defaultDates()
      this.$emit('update:query-params', obj)
    },
    onSubmit() {
      // let searchCondition = this.handleSearchCondition()
      // this.$emit('onSubmit', searchCondition)
      this.$emit('handleQuery', this.handleSearchCondition())
    },
    handleQuery() {
      this.$emit('handleQuery', this.handleSearchCondition())
    },

    //选择平台
    changePlatform(val) {
      this.searchCondition.platform = val;
    },
    timestampQueryChange() {
      this.searchCondition.begin_timestamp = this.timestampQuery ? this.timestampQuery[0] : ''
      this.searchCondition.end_timestamp = this.timestampQuery ? this.timestampQuery[1] : ''
    },
    // 处理搜索条件
    handleSearchCondition() {
      return filterSearchCondition(this.searchCondition)
    },
    //下拉框数据加载
    //红人
    getFBoySelectList() {
      try {
        if (this.optionsMap.artistOption.length === 0) {
          getFBoyOption({}).then((_list) => {
            if (Array.isArray(_list.model) && _list.model.length > 0) {
              this.optionsMap.artistOption = _list.model
            }
          });
        }
        // eslint-disable-next-line
      } catch (error) {
      }
    },
    //销售
    getOptionSales() {
      if (this.optionsMap.saleOption.length === 0) {
        optionsUsers({type: 'SALE'}).then(res => {
          this.optionsMap.saleOption = res.model;
        });
      }
    },
    //执行
    getOptionExecutor() {
      if (this.optionsMap.executors.length === 0) {
        optionsUsers().then(res => {
          this.optionsMap.executors = res.model;
        });
      }

    },
    //配置项目
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        this.optionsMap.order_source = res.model.order_source || [];
        this.optionsMap.form_of_cooperations = res.model.form_of_cooperation || [];
        this.optionsMap.productCategoriesOptions = res.model.product_category || [];
      });
    },
    pageJump(routeName) {
      const {href} = this.$router.resolve({
        name: routeName
      });
      window.open(href, "_blank");
    },
    // 获取小组列表
    getTeamList() {
      options().then(res => {
        if (res.success) {
          this.organizationOptions = res.model;
          return false
        }
        this.$message.error(res.message);
      })
    },
    getCustomerNaturesOptions() {
      let option = ['customer_natures', 'customer_types']
      getOptionItems(option).then(res => {
        this.customerNaturesOptions = res.model['customer_natures']
        this.customerTypesOptions = res.model['customer_types']
      })
    }
  }
}
</script>

<style lang="scss">
.order-search-container {

  .el-form-item {
    width: 100%;
    margin-bottom: 5px !important;
    margin-right: 0;

    .el-form-item__content {
      width: 100%;
    }
  }

  .el-col {
    padding-right: 10px;
  }

  .el-select {
    width: 100%;

    .el-select__tags {
      max-width: unset !important;
    }

    .el-select__input {
      max-width: unset !important;
    }
  }

  .company {
    width: 110px !important;
  }

  .customer {
    width: 100%;
    margin-left: 10px;

    .el-select {
      width: calc(100% - 132px) !important;
    }
  }

  .width-100 {
    width: 100%;

    div {
      width: 100%;
    }
  }

  .btn-export {
    margin-left: 10px;

    .el-button--text {
      font-size: 14px !important;
    }

    .content {
      display: contents;
    }
  }

  .handel {
    .el-form-item__content {
      text-align: left;
    }
  }
}
</style>
